module.exports = __webpack_public_path__ + "files/4f7cd5aae0e2d3489a12a765dff1a499.png";